<template>
  <v-layout row justify-center class="my-0 py-0">
    <v-dialog v-model="ticket_dialog" persistent max-width="80%" scrollable>
      <v-card v-if="ticket_dialog">
        <v-card-title class="primary lighten-3 background--text">
          <span class="title">{{
            $t("screener.physical.tickets.dialog.title")
          }}</span>
          <v-spacer></v-spacer>
          <v-btn
            small
            color="primary background--text"
            v-print="'#ticket'"
            v-if="$vuetify.breakpoint.width > 959"
            ><v-icon small class="mr-1">$vuetify.icons.rms_print</v-icon
            >{{$t('screener.btn.print')}}</v-btn
          >
          <v-btn
            small
            :loading="isGeneratingPdf"
            color="primary background--text"
            @click.stop="generateReport"
            ><v-icon small class="mr-1">$vuetify.icons.rms_download</v-icon
            >{{$t('screener.btn.download')}}</v-btn
          >
        </v-card-title>
        <v-card-text v-if="booking" class="white">
          <vue-html2pdf
            :html-to-pdf-options="pdf_options"
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1100"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            @hasDownloaded="pdfGenerated"
            ref="html2Pdf"
            pdf-content-width="100%"
          >
            <section slot="pdf-content">
                 <Ticket
                    :qrCode="booking.code"
                    :booking="booking"
                ></Ticket>
            </section>
          </vue-html2pdf>
        </v-card-text>
        <v-card-text class="white">
          <v-container grid-list-md>
               <Ticket
                    :qrCode="booking.code"
                    :booking="booking"
                    id="ticket"
                ></Ticket>
          </v-container>
        </v-card-text>
        <v-card-actions class="white">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="copy_dialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import Ticket from "@/components/screener/physicalEvent/Ticket"
import VueHtml2pdf from "vue-html2pdf";
export default {
  props:{
        booking:{
            type:Object,
            default:{}
        },
        ticket_dialog:{
            type:Boolean,
            default:false
        }
    },
  name: "TicketsDialog",
  data() {
    return {
      isGeneratingPdf: false,
      copy_dialog: this.ticket_dialog,
      pdf_options:{
        enableLinks:true,
        image: {
          type: 'jpeg', 
          quality: 0.50
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          scrollX: 0,
		      scrollY: 0
        },
      }
    };
  },
   watch: {
    copy_dialog: {
      handler: function () {
        this.$emit("update:ticket_dialog", this.copy_dialog);
      },
    },
    ticket_dialog: {
    handler: function (newVal, oldVal) {
        if(newVal){
            this.copy_dialog = true
        }
      },
    }
   },
  components: {
    Ticket,
    VueHtml2pdf,
  },
  methods: {
    pdfGenerated(event){
        this.isGeneratingPdf = false;
    },

    generateReport() {
        this.isGeneratingPdf = true;
        this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

